module.exports = __webpack_public_path__ + "img/016.d4269fe3.jpg";